<template>
    <v-container fluid>
        <v-card >
            <v-toolbar>
                <v-icon>attach_money</v-icon>
                <v-toolbar-title class="font-weight-light">Modificación de Plan de Crédito</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
        
            <v-card-text>
                <v-container fluid>
                    <v-layout column>
                        <v-flex xs12 >
                            <v-card dark color="blue ligthten-3">
                                <v-card-text>
                                <div >{{Solicitud.infoCredito}} </div>
                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 >
                            <v-checkbox label="Modificar Situación Crédito" v-model="modificaSituacion"></v-checkbox>
                            <v-autocomplete v-model="nuevaSituacionId" :items="listSituacionesCredito" autocomplete="disabled"
                                item-text="descripcion" item-value="id" label="Genera Crédito" :menu-props="{minWidth:'200'}"  :disabled="!modificaSituacion"></v-autocomplete>                                    

                            <v-row v-if="modificaSituacion && (nuevaSituacionId == 3 ||  nuevaSituacionId == 4)" align="center" dense>
                                <v-col cols="6">
                                    <v-switch v-model="ingresarImporte" label="Ingresar Importe" hint="" ></v-switch>
                                </v-col>
                                <v-col v-if="ingresarImporte">
                                    <v-text-field label="Importe Renovación" v-model="importeRenovacion"></v-text-field>
                                </v-col>
                                <v-col v-else cols="6">                                    
                                    <app-creditos-para-refinanciar-renovar :personaId.sync="Solicitud.personaId" :empresaId="Solicitud.empresaId"
                                        :selectedCuotas.sync="cuotasARefinanciarORenovar" v-on:listchange="cuotasARefinanciarORenovar =$event"></app-creditos-para-refinanciar-renovar>                                
                                </v-col>
                            </v-row>                        
                        </v-flex>

                        <v-flex xs12 >
                            <v-checkbox label="Modificar Capital" v-model="modificaCapital"></v-checkbox>
                            <v-text-field label="Capital" :disabled="!modificaCapital" v-model="nuevoCapital"></v-text-field>
                        </v-flex>
                        <v-flex xs12 >
                            <v-checkbox label="Modificar Plan y Cuotas" v-model="modificaPlan"></v-checkbox>
                           
                           <v-flex v-if="modificaPlan">
                            <v-autocomplete v-model="nuevoPlanId" :items="listPlanesDisponibles" :disabled="!modificaPlan" :loading="loading"  @change="selectedPlanChanged"
                                  item-text="planNombre" item-value="planId" label="Planes Disponibles" :menu-props="{minWidth:'200'}"></v-autocomplete>                            

                            <v-chip v-if="this.listPlanes && this.listPlanes.filter(p=>!p.estaDisponible).length >0" color="red" text-color="white" @click="showPlanesNoDisponibles = true">Hay Planes no disponibles</v-chip>

                            <v-flex >
                              <v-card>
                                <v-card-title>
                                  <h6>Opciones de Cuotas para un capital del $ {{ nuevoCapital }} en </h6>
                                </v-card-title>
                                <v-card-text>
                                  <v-radio-group row v-model="nuevaCantidadDeCuotas" :disabled="!modificaPlan">
                                    <v-radio v-for="item in opcionesPlanes" 
                                        :key="item.cuotas" 
                                        :label="item.oferta" 
                                        :value="item.cuotas"></v-radio>                                
                                  </v-radio-group>     
                                </v-card-text>
                              </v-card>
                            </v-flex>
                           </v-flex>
                        </v-flex>
                        <v-flex xs12 >
                            <v-text-field label="Ingrese el Motivo del Cambio" v-model="motivoCambio"></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>

            </v-card-text>
            <v-card-actions>
                <v-btn color="cancel" @click="cancelar">Cancelar</v-btn>
                <v-spacer></v-spacer>
                <v-btn  color="success" @click="confirmar" :disabled="!modificaCapital && !modificaPlan && !modificaSituacion">Confirmar</v-btn>
            </v-card-actions>
        </v-card>

        <!-- planes no disponibles -->
        <v-dialog v-model="showPlanesNoDisponibles" width="600">
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro" >
            <v-card-title class="headline" >Planes No disponibles</v-card-title>
            <v-card-text>
                <v-layout wrap>
                <v-list>
                    <v-list-item v-for="item in listPlanes.filter(p=>!p.estaDisponible)" :key="item.planId">
                    <template>
                        <h5>{{item.planNombre}}: </h5> <div class="caption">{{item.motivoNoDisponible}}</div>
                    </template>    
                    </v-list-item>
                </v-list>
                </v-layout>
            </v-card-text>
        </v-card>
        </v-dialog>
    </v-container>
    
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data () {
        return {
            loading: false,
            modificaSituacion: false,
            nuevaSituacionId: false,
            modificaCapital: false,
            modificaPlan: false,
            modificaCuotas: false,
            nuevoCapital: 0,
            nuevoPlanId: 0,
            nuevaCantidadDeCuotas: 0,
            motivoCambio: '',
            listPlanes:[],
            listPlanesDisponibles:[],
            listSituacionesCredito: [],
            opcionesPlanes:[],
            cuotas: [],
            ingresarImporte: true,
            cuotasARefinanciarORenovar: [],
            importeRenovacion: 0,
            showPlanesNoDisponibles: false,
        }
    },
    async created() {
        this.loadSituacionesCredito();
    },
    props:{
        Solicitud: {
            type: Object,
        },
        Ok: Function,
        Cancel: Function,
    }, 
    watch:{ 
        'modificaPlan': function(){
            if(this.modificaPlan){
                if(this.nuevoCapital ==0)
                    this.nuevoCapital = this.Solicitud.capital;
                this.loadPlanesDisponibles();
            }
        },
        'modificaCapital': function(){
            this.nuevoCapital = this.Solicitud.capital;
        },
        'Solicitud': function(){
            if(this.Solicitud){
               this.loadData();
            }
        },
    },  
    methods:{
        ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
        loadData(){
            this.nuevoCapital = this.Solicitud.capital;
            this.nuevoPlanId = this.Solicitud.planId;
            this.nuevaSituacionId = this.Solicitud.situacionCreditoId;
            this.cuotasARefinanciarORenovar= this.Solicitud.cuotasARefinanciarORenovar;
            this.importeRenovacion= this.Solicitud.importeRenovacion;
            this.ingresarImporte = this.cuotasARefinanciarORenovar && this.cuotasARefinanciarORenovar.length == 0;
        },
        async confirmar(){
            if(this.cuotasARefinanciarORenovar.length > 0)
                this.importeRenovacion = 0;

            if(this.modificaSituacion && (this.nuevaSituacionId == this.Solicitud.situacionCreditoId && this.importeRenovacion == this.Solicitud.importeRenovacion && this.cuotasARefinanciarORenovar.length == this.Solicitud.cuotasARefinanciarORenovar.length)){
                this.alertWarning('Se marcó Modificar Situación, pero es igual al cargado para la solicitud. Por favor, verifique, o destilde la opción.');
                return;
            }

            if(this.modificaCapital && (this.nuevoCapital == this.Solicitud.capital)){
                this.alertWarning('Se marcó Modificar Capital, pero es igual al cargado para la solicitud. Por favor, verifique, o destilde la opción.');
                return;
            }
            
            if(this.modificaPlan && (this.nuevoPlanId == this.Solicitud.planId && this.nuevaCantidadDeCuotas == this.Solicitud.cuotas)){
                this.alertWarning('Se marcó Modificar Plan y Cuotas, pero no se detectaron cambios. Por favor, verifique, o destilde la opción.');
                return;
            }

            if(this.motivoCambio == ''){
                this.alertWarning('Por favor, ingrese el motivo del cambio');
                return;
            }

            Vue.$log.debug(this.Solicitud)

            var params = {};
            params.creditoId = this.Solicitud.id;
            params.capital = this.nuevoCapital;
            params.modificaCapital = this.modificaCapital;
            params.cuotas = this.nuevaCantidadDeCuotas;
            params.planId = this.nuevoPlanId;
            params.modificaPlan = this.modificaPlan;
            params.modificaCuotas = this.modificaPlan;
            params.modificaSituacion = this.modificaSituacion;
            params.situacionCreditoId = this.nuevaSituacionId ? this.nuevaSituacionId : this.Solicitud.situacionCreditoId;
            params.importeRenovacion = this.importeRenovacion;
            params.cuotasARefinanciarORenovar = this.cuotasARefinanciarORenovar;

            params.motivo = this.motivoCambio;

            Vue.$log.debug(params)
            this.loading = true

            try {
                var res = await http.post('creditos/actualizarcapitalcuotasoplandesolicitud', JSON.stringify( {parametros:  params} ) );

                Vue.$log.debug(res);
                this.alertSuccess('Se han modificado los datos del crédito.')

                this.cleanUp();
                this.Ok();
            } catch (error) {
                // Error
                this.alertError(error)
            }
            this.loading = false            
        },
        async cancelar(){
            this.modificaCapital = false;
            this.modificaPlan = false;
            this.modificaSituacion = false;
            
            this.loadData();
            this.Cancel();
        },
        async cleanUp(){
            this.modificaCapital = false;
            this.modificaPlan = false;
            this.modificaSituacion = false;
            this.nuevoCapital = 0;
            this.nuevoPlanId = 0;
            this.nuevaCantidadDeCuotas = 0;
            this.motivoCambio = '';
            this.listPlanes = [];
            this.listPlanesDisponibles=[];
            this.cuotasARefinanciarORenovar = [];
            this.importeRenovacion =0;
            this.nuevaSituacionId = 1;
        },
        async loadSituacionesCredito(){
            this.loading = true
            try {
                var result = await http.get('tipossituacioncredito' ); 

                this.listSituacionesCredito = result.list;
            } catch (error) {
                // Error
                this.alertError(error)
            }
            this.loading = false
        },
        async loadPlanesDisponibles(){
            this.opcionesPlanes = [];
            this.loading = true
            try {
                var result = await http.get('businesscore/planesdisponiblesparacredito' 
                    + '?productoId='+ this.Solicitud.productoId
                    + '&empresaId='+ this.Solicitud.empresaId 
                    + '&canalVentaId='+ this.Solicitud.canalVentaId
                    + '&calificacionPersonaId='+ this.Solicitud.tipoCalificacionId); 

                this.listPlanes = result.list;
                this.listPlanesDisponibles = this.listPlanes.filter(p=>p.estaDisponible);
                if(result.list.length == 0){
                    this.nuevoPlanId = 0
                    this.alertWarning('El producto seleccionado no tiene Planes vigentes que estén disponibles. Utilice otro producto.')
                }
                else{
                    this.nuevoPlanId = result.list[0].planId
                    await this.calcularOpcionesPlan()
                }

            } catch (error) {
                // Error
                this.alertError(error)
            }
            this.loading = false
        },
        async selectedPlanChanged(value){
            if(value == 0) return;
            this.calcularOpcionesPlan();      
        },
        async calcularOpcionesPlan(){
            this.opcionesPlanes = [];

            if(this.Solicitud.capital == 0 )
                return;

            this.loading = true
            try {
                var result = await http.get('businesscore/calcularopcionesplanparacredito' 
                    + '?planId='+ this.nuevoPlanId
                    + '&empresaId='+ this.Solicitud.empresaId 
                    + '&canalVentaId='+ this.Solicitud.canalVentaId
                    + '&calificacionPersonaId='+ this.Solicitud.tipoCalificacionId
                    + '&politicaComercialId='+ this.Solicitud.politicaComercialId
                    + '&diaCobro='+ '0' 
                    + '&capital='+ this.nuevoCapital
                    + '&importeCuotaMaximo=0'
                    + '&fechaCarga='+ this.Solicitud.fechaIngreso
                    + '&excepcionAprobada=true'); // por defecto en esta instancia la política se asume aprobada

                this.opcionesPlanes = result.list;
                if(result.list.length == 0){
                    this.alertWarning('No se encontraron opciones de cuota para el plan seleccionado.')
                }

            } catch (error) {
                // Error
                this.alertError(error)
            }
            this.loading = false
        },
    },
    
}
</script>
